
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function scopeProduct1() {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn cm_button cm_button__secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '331'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', { 'className': 'card' }, [scopeProduct1.apply(this, [])], _createElement('a', { 'href': this.url }, this.on_sale && this.calcDiscount(this.price, this.compare_at_price) > 0 ? _createElement('span', {
                    'className': 'number',
                    'key': '480'
                }, '\n      -', this.calcDiscount(this.price, this.compare_at_price), '%\n    ') : null, _createElement('img', {
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError,
                    'loading': 'lazy'
                }), _createElement('div', { 'className': 'info' }, _createElement('p', mergeProps({ 'className': 'ssc-title-slide' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'product-price' }, this.on_sale ? _createElement('s', {
                    'className': 'product-price__price custom-price-sale',
                    'key': '1044'
                }, _createElement('span', { 'className': 'money' }, ' ', this.formatPrice(this.compare_at_price), ' ')) : null, _createElement('span', { 'className': 'product-price__price product-price__sale' }, _createElement('span', { 'className': 'money' }, this.price_varies ? _createElement('span', { 'key': '1317' }, _translate(`price_from`), ' ') : null, this.formatPrice(this.min_price || this.price), '\n          '))))), _createElement('div', { 'className': 'junip-product-summary-wrapper' }, _createElement('span', {
                    'className': 'junip-product-summary',
                    'data-product-id': this.id
                }), _createElement('a', {
                    'href': this.url + '#reviews',
                    'className': 'text-reviews'
                }, 'See all reviews')));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []